import React from "react";
import { Link } from "react-router-dom";

import { ReactComponent as Logo } from "../../../../assets/svg/logo.svg";
import { loginPath } from "../../../../teacherStore";
import { emailRegex } from "../../../../constants/regex";
import styles from "../Login.module.scss";

type Props = {
  forgotPassword: (email: string) => void;
};

const validates: { [key: string]: (value: any) => string } = {};

validates["email"] = val => {
  return !val.email.trim()
    ? "この項目は入力が必須です。"
    : val.email.match(emailRegex)
    ? ""
    : "正しいメールアドレスを入力してください。";
};

export const ForgotPassword = (props: Props) => {
  const [state, setState] = React.useState({
    email: "",
    errorMessages: {} as { [key: string]: string },
  });

  const onSubmit = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      const errorMessages = {} as { [key: string]: string };
      Object.keys(validates).forEach(key => {
        const ret = validates[key](state);
        if (ret) {
          errorMessages[key] = ret;
        }
      });
      if (Object.keys(errorMessages).length > 0) {
        setState(s => ({ ...s, errorMessages }));
        return;
      }
      props.forgotPassword(state.email);
    },
    [props, state],
  );

  const onChange = React.useCallback(
    (e: React.SyntheticEvent<HTMLInputElement>) => {
      e.preventDefault();
      const val = e.currentTarget.value;
      const key = e.currentTarget.name;
      const args = { [key]: val };
      const ret = validates[key](args);
      setState(prevState => ({
        ...prevState,
        [key]: val,
        errorMessages: { ...prevState.errorMessages, [key]: ret },
      }));
    },
    [],
  );

  return (
    <div className={styles.wrapper}>
      <Logo className={styles.logo} />
      <form className={styles.content} onSubmit={onSubmit}>
        <div className={styles.title}>
          <p className={styles.primary}>パスワード再発行</p>
        </div>
        <p className={styles.text}>
          ご登録のメールアドレスを入力してください。
          <br />
          パスワードを再設定するためのメールをお送りします。
        </p>
        <div className={styles.inputField}>
          <fieldset>
            <input
              type="email"
              name="email"
              className={state.errorMessages["email"] ? styles.isError : ""}
              id="email"
              value={state.email}
              onChange={onChange}
              onBlur={onChange}
              placeholder="メールアドレスを入力"
            />
            {state.errorMessages["email"] && (
              <p className={styles.errorMessage}>
                {state.errorMessages["email"]}
              </p>
            )}
          </fieldset>
        </div>
        <button
          className={styles.submitButton}
          type="submit"
          disabled={
            Object.keys(state.errorMessages).filter(k => state.errorMessages[k])
              .length > 0
          }
        >
          送信
        </button>
        <p className={styles.textCenter}>
          <Link className={styles.link} to={loginPath}>
            ログイン画面に戻る
          </Link>
        </p>
      </form>
    </div>
  );
};

export default ForgotPassword;
